import { useMemo } from 'react';

import { FormContainerProps } from '@occc-app/offerHelpers/types';
import { useGetConfigureFormProps } from '@occc-app/offerHelpers/hooks/useGetConfigureFormProps';
import { useChainId } from '@occc-app/Chain/hooks';
import { Offer_Engagement_Type, OfferFilter, Publication_Status_Type } from '@occc/graphql';
import { CampaignComponentTabs } from '@occc-app/routes/CampaignComponents/components/ConfigurationLayout';

import { ConfigureForm } from './ConfigureForm';
import { transformOfferToInitialValues } from './utils/configureFormInitialValues';
import { getConfigureFormOperations } from './utils/configureFormOperations';

import { GameConfigureFormValues } from '../types';

export const createOffersFilterMaker =
  (chainId: string) => (engagementTypes: Offer_Engagement_Type[]) => (): OfferFilter => ({
    chainIdEquals: chainId,
    engagementTypeIncludes: engagementTypes,
    deleted: false,
    publicationStatusEquals: Publication_Status_Type.Published,
  });

export const GameConfigureFormContainer = (props: FormContainerProps) => {
  const configureProps = useGetConfigureFormProps<GameConfigureFormValues, GameConfigureFormValues>(
    props,
    transformOfferToInitialValues,
    getConfigureFormOperations,
  );

  const chainId = useChainId();
  const getOffersFilterMaker = useMemo(() => createOffersFilterMaker(chainId), [chainId]);

  const onNextStepButtonClick = () => {
    props.setTabValue(CampaignComponentTabs.Target);
  };

  return (
    <ConfigureForm
      {...configureProps}
      offerType={props.type}
      getOffersFilterMaker={getOffersFilterMaker}
      onNextStepButtonClick={onNextStepButtonClick}
    />
  );
};
